module.exports = __webpack_public_path__ + "img/backtop.13760477.svg";